import { SpeedTable } from 'constants/speed'

export const random = ( min, max ) => {
	return Math.random() * ( max - min ) + min;
};

export const calculateAnimationDelay = (speed) => {
	const hopperSpeed = SpeedTable[speed].HOPPER_SPEED;
	return (hopperSpeed * 20) + (hopperSpeed * 3);
}